type PlainButtonProps = {
  buttonAction?: () => void;
  children?: React.ReactNode;
  styleClass?: Object;
  disabled?: boolean;
};

const commonStyleSteet = {
  padding: '8px',
  borderRadius: '4px',
  fontSize: '12px',
  cursor: 'poiner'
};
export default function PlainButton({
  buttonAction = () => {},
  disabled = false,
  children,
  styleClass = {}
}: PlainButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`btn btn-outline-secondary whiteButton h7_400 m-1`}
      style={{
        border: 'none',
        color: 'var(--uni_std_clr)',
        boxShadow: '0px 0.5px 2.5px 0px rgba(0, 0, 0, 0.3)',
        ...commonStyleSteet,
        ...styleClass
      }}
      onClick={buttonAction}>
      {children}
    </button>
  );
}

export function UnileverButton({
  buttonAction = () => {},
  children,
  styleClass = '',
  disabled = false
}: PlainButtonProps) {
  return (
    <button
      disabled={disabled}
      className={`btn m-1 ${
        disabled ? 'btn btn-outline-secondary whiteButton h7_400' : 'blueButton'
      }  `}
      type="submit"
      style={{
        boxShadow: disabled ? '0px 0.5px 2.5px 0px rgba(0, 0, 0, 0.3)' : '',
        ...commonStyleSteet,
        ...styleClass
      }}
      onClick={buttonAction}>
      {children}
    </button>
  );
}
